<template>
  <div class="teres">
    <div class="container">
      <error-message v-if="permissionerror" i18nMessage="common.permissionerror" />
      <privacy-overlay v-if="!permissionerror && privacyNotice === false" />
      <info-popup v-if="!permissionerror && privacyNotice === true" />
      <router-view v-if="!permissionerror && privacyNotice === true" />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import config from '@/config/config'
import ErrorMessage from '@/components/feedback/ErrorMessage.vue'
import { GuiOptions } from './models/GuiOptions'
import InfoPopup from './components/interaction/InfoPopup.vue'
import PrivacyOverlay from './components/structure/PrivacyOverlay.vue'
import { loadRecaptcha } from './utils/domUtils'

export default defineComponent({
  name: 'TeresApp',
  components: {
    ErrorMessage,
    InfoPopup,
    PrivacyOverlay
  },
  data() {
    return {
      permissionerror: config.interface === GuiOptions.permissionerror
    }
  },
  created() {
    if (config.interface === GuiOptions.user && this.$store.state.privacyNotice) {
      loadRecaptcha()
    }
  },
  computed: {
    privacyNotice() {
      if (config.interface !== GuiOptions.user) {
        return true
      }
      return this.$store.state.privacyNotice
    }
  }
})
</script>
